import React, { ReactNode, useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';

const Arrow = (props: any) => (
    <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M1.33203 0.999939L9.33203 8.99994L1.33203 16.9999" stroke="#707070" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

interface ModuleTabsProps<T> {
    list: {
        label: ReactNode;
        value: T;
    }[];
    value: T;
    onChange?: (value: T) => void;
    contentRef: React.RefObject<HTMLDivElement>;
}

function ModuleTabs<T>({ list, value, contentRef, onChange }: ModuleTabsProps<T>) {
    const prevButton = useRef<HTMLDivElement>(null);
    const nextButton = useRef<HTMLDivElement>(null);
    const swiperRef = useRef<HTMLDivElement>(null);
    const [showNavigation, setoShowNavigation] = useState(false);
    const [swiperGap, setSwiperGap] = useState(24);
    const [isWeb, setIsWeb] = useState(false);
    useEffect(() => {
        if (!contentRef.current) return;
        const observer = new ResizeObserver((entries) => {
            entries.forEach((entry) => {
                if (!contentRef.current || !swiperRef.current) return;
                if (swiperRef.current.offsetWidth === contentRef.current.offsetWidth) {
                    setoShowNavigation(true);
                } else {
                    setoShowNavigation(false);
                }
                const { inlineSize } = entry.borderBoxSize[0];
                if (inlineSize > 1024) {
                    setSwiperGap(40);
                    setIsWeb(true);
                } else {
                    setIsWeb(false);
                    setSwiperGap(32);
                }
            });
        });
        observer.observe(contentRef.current);
        return () => {
            observer.disconnect();
        };
    }, [contentRef]);

    return (
        <div className={`module-tabs-content ${css['Support']}`}>
            {/* @ts-ignore */}
            <div style={{ width: 'fit-content', maxWidth: '100%', '--module-tabs-gap': `${swiperGap}px` }} ref={swiperRef}>
                <Swiper
                    className="module-tabs"
                    spaceBetween={swiperGap}
                    navigation={{
                        nextEl: nextButton.current, // 指定下一个按钮的选择器
                        prevEl: prevButton.current, // 指定上一个按钮的选择器
                    }}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    slidesPerGroup={!isWeb ? 1 : 2}
                    onSlideChange={(swiper) => {
                        if (!prevButton.current || !nextButton.current) return;
                        if (swiper.isBeginning) {
                            prevButton.current.style.display = 'none';
                        } else {
                            prevButton.current.style.display = 'flex';
                        }
                        if (swiper.isEnd) {
                            nextButton.current.style.display = 'none';
                        } else {
                            nextButton.current.style.display = 'flex';
                        }
                    }}
                >
                    {list.map((i) => (
                        <SwiperSlide
                            className={`module-tabs-item ${i.value === value ? 'active' : ''}`}
                            onClick={() => onChange?.(i.value)}
                            style={{ width: 'fit-content' }}
                            key={i.value as number}
                        >
                            {i.label}
                        </SwiperSlide>
                    ))}
                </Swiper>
                <div
                    className="module-tabs-btn module-tabs-btn-left"
                    ref={prevButton}
                    style={{ display: 'none', opacity: showNavigation && isWeb ? 1 : 0, pointerEvents: showNavigation && isWeb ? 'all' : 'none' }}
                >
                    <Arrow style={{ transform: 'scaleX(-1)' }} />
                </div>
                <div
                    className="module-tabs-btn module-tabs-btn-right"
                    ref={nextButton}
                    style={{ opacity: showNavigation && isWeb ? 1 : 0, pointerEvents: showNavigation && isWeb ? 'all' : 'none' }}
                >
                    <Arrow />
                </div>
            </div>
        </div>
    );
}
export default ModuleTabs;
